import React, { useEffect, useState } from "react";
import Select, { createFilter, OptionsType } from "react-select";
import { FixedSizeList as List } from "react-window";
import "./Select.css";

export class MenuList extends React.Component<any> {
  height: number = 35;

  render() {
    const { options, children, maxHeight, getValue } = this.props;
    const [value] = getValue();
    const initialOffset = options.indexOf(value) * this.height;

    return (
      <List
        height={maxHeight}
        // @ts-ignore
        itemCount={children.length}
        itemSize={this.height}
        initialScrollOffset={initialOffset}
        width="100%"
      >
        {({ index, style }) => {
          // @ts-ignore
          return <div style={style}>{children[index]}</div>;
        }}
      </List>
    );
  }
}

let allCities: Array<{ label: string; value: string }> = [];

const SelectCity: React.FunctionComponent<{
  onChange?: (e: { label: string; value: string }) => void;
  value?: string;
}> = (props: {
  onChange?: (e: { label: string; value: string }) => void;
  value?: string;
}) => {
  const [value, setValue] = useState<string>(props.value ? props.value : "");
  const [cities, setCities] = useState<
    OptionsType<{ label: string; value: string }>
  >([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [selected, setSelected] = useState<boolean>(false);

  useEffect(() => {
    setLoading(true);
    fetch(process.env.REACT_APP_BASE_URL + "/cities.json", {
      headers: {
        "Content-Type": "application/json",
      },
      mode: "cors",
    })
      .then((res) => res.json())
      .then((data: string[]) => {
        setLoading(false);
        const mappedOptions = data.map((item) => {
          const label = item.toLowerCase().replace(/\b\w{3,}/g, function (l) {
            return l.charAt(0).toUpperCase() + l.slice(1);
          });
          return { label: label + ", IL", value: item };
        });
        allCities = mappedOptions;
      });
  }, []);

  const handleInputChange = (e: string) => {
    setValue(e);
    if (e.length > 2) {
      setCities(
        allCities.filter((c) =>
          c.value.toLocaleLowerCase().includes(e.toLocaleLowerCase())
        )
      );
    }
    setSelected(true);
  };

  const handleChange = (e: { label: string; value: string } | null) => {
    if (e) {
      setValue(e.value);
      if (props.onChange) props.onChange(e);
    }
    setSelected(false);
  };

  return (
    <div>
      <Select
        options={cities}
        onChange={handleChange}
        isLoading={loading}
        isDisabled={loading}
        value={{ label: value ? value + ", IL" : "Search City", value }}
        // @ts-ignore
        // components={{ MenuList }}
        components={{
          DropdownIndicator: () => null,
          IndicatorSeparator: () => null,
        }}
        filterOption={createFilter({ ignoreAccents: true })}
        className="select-menu"
        openOnFocus={false}
        openOnClick={false}
        onFocus={() => setSelected(true)}
        menuIsOpen={value.length > 2 && selected}
        onInputChange={handleInputChange}
        placeholder="Search City"
      />
    </div>
  );
};

export default SelectCity;
